<template>
  <!-- 创建项目 author: zhangxiaofeng -->
  <div class="project-add" :class="{'has-background': showBackgroundColor}">
    <h3 class="content_title--goback" v-if="showHeader">
      <router-link tag="span" :to="path">
        <i class="r2-icon-hardware_keyboard_backspace_outlined margin-right-5"></i>创建项目
      </router-link>
    </h3>
    <div class="content_body" :class="{'has-margin': showHeader, 'has-background': showBackgroundColor}">
      <w-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" style="padding: 40px 48px 48px 48px;">
        <w-form-item label="项目编号" prop="prjNumber">
          <w-input size="small" v-model="form.prjNumber" placeholder="请输入项目编号" style="width: 400px;"></w-input>
        </w-form-item>
        <w-form-item label="项目名称" prop="prjName">
          <w-input size="small" v-model="form.prjName" placeholder="请输入项目名称" style="width: 400px;"></w-input>
        </w-form-item>
        <w-form-item label="造价文件编制方式">
          <w-checkbox  @change="changeCategory" disabled v-model="form.prjCategory" :true-label="1" :false-label="0">计价协同</w-checkbox>
        </w-form-item>
        <w-form-item label="项目存储方式" prop="prjType">
          <w-row class="inline-block">
            <w-radio style="width: 126px;" v-model="form.prjType" label="1" name="prjType" :disabled="!!form.prjCategory">按项目阶段存储</w-radio>
            <el-tooltip style="position: relative;top: -2px;" effect="dark" placement="right">
              <div slot="content" class="statu-info">
                <p>按工程所处不同阶段创建项目模板，便于项目资料及数据分阶段、分类型存储及管理。</p>
                <div>
                  <template v-for="(value, key, index) in statusMessage">
                    <div v-if="value.length>0" :key="index"
                         class="flex flex-rowr message-item"
                         :class="{'after-border':index<status.length-1}"
                    >
                      <div class="width-100">{{key}}</div>
                      <div class="flex-1 tab">
                      <span class="tab-item" :key="item" v-for="item of value.split(',')">
                        <i class="r2-icon-file_folder margin-right-5"></i>
                        {{item || '无'}}
                      </span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <i class="r2-icon-action_help_outline margin-right-40" style="color: rgba(33, 37, 48, 0.55);" @mouseover="prjTypeHover(1)"></i>
            </el-tooltip>
          </w-row>
          <w-row class="inline-block">
            <w-radio style="width: 100px;" v-model="form.prjType" label="0" name="prjType" :disabled="!!form.prjCategory">自定义存储</w-radio>
            <el-tooltip style="position: relative;top: -2px;" effect="dark" content="按自定义新建，可以自己按需创建文件夹存储及管理" placement="right">
              <i class="r2-icon-action_help_outline" style="color: rgba(33, 37, 48, 0.55);" @mouseover="prjTypeHover(0)"></i>
            </el-tooltip>
          </w-row>
        </w-form-item>
        <w-form-item>
          <!--label="项目成员"-->
          <template slot="label">项目成员
            <el-tooltip style="position: relative;top: -2px;" effect="dark" content="备案后，该项目资料仅项目成员可见。" placement="right" v-if="showMemberTips">
              <i class="r2-icon-action_help_outline" style="color: rgba(33, 37, 48, 0.55);"></i>
            </el-tooltip>
          </template>
          <div>
            <w-tag v-for="tag in sellist" :name="tag.id" :key="tag.id" color="primary" closable @close="closeHandle(tag)" class="margin-right-10">
              {{tag.name}}
            </w-tag>
            <w-button @click.stop.prevent="addMember()">添加成员</w-button>
          </div>
        </w-form-item>
        <w-form-item label="项目概况" prop="description">
          <w-input
            type="textarea"
            :rows="3"
            placeholder="请输入项目概况(最多200字)"
            v-model="form.description"
            style="width: 600px;">
          </w-input>
        </w-form-item>
        <w-form-item class="form-footer">
          <w-button type="primary" @click.stop.prevent="submitHandle()">确定{{isEditor ? '修改' : '创建'}}</w-button>
          <w-button type="minor" @click.stop.prevent="cancelHandle()" v-if="!isEditor">取消</w-button>
        </w-form-item>
      </w-form>
    </div>
    <w-dialog :show="show" title="添加成员" @close="$refs.addMember.close()" :box-style="{width: '1058px', zIndex: 1009}" :bodyStyle="{padding: 0}">
      <AddMember
        ref="addMember"
        :AddMemberShow="show"
        :sellist="sellist"
        :MemberInfo="MemberInfo"
        v-on:closeMemberShow="show=false"
        v-on:sellListCallBack="sellListCallBack"
      ></AddMember>
      <div slot="footer">
        <w-button type="primary" @click="$refs.addMember.confirm()">确定</w-button>
        <w-button type="minor" @click="$refs.addMember.close()">取消</w-button>
      </div>
    </w-dialog>
  </div>
</template>
<style lang="less">
  .project-add {
    .w__form-item__label {
      text-align: left;
      font-weight: 500;
      &::before{
        margin-right: 8px!important;
      }
    }
    .w__form-item{
      margin-bottom: 32px;
    }
    .form-footer{
      margin-top: 64px;
      .w__form-item__content{
        margin-left: 12px!important;
      }
    }
  }
</style>
<style lang="less" type="text/less" scoped>
  .width-100 {
    width: 90px;
  }
  .content_title--goback {
    height: 48px;
    box-shadow: 0px -1px 0px 0px rgba(224, 226, 229, 1);
    background: #fff;
    line-height: 48px;
    font-size: 16px;
    color: rgba(33, 37, 48, 1);
    padding-left: 24px;
    font-weight: 500;
    span {
      cursor: pointer;
    }
  }
  .project-add {
    &.has-background {
      background: rgba(243, 244, 247, 1);
    }
    height: 100%;
    .w__radio {
      margin-right: 5px;
    }
  }
  .content_body {
    min-height: 598px;
    background: #fff;
    &.has-margin {
      margin: 24px 24px 0 24px;
    }
    &.has-background {
      box-shadow: 0px 1px 4px 0px rgba(33, 37, 48, 0.1);
      border-radius: 2px;
    }
    .form {
      padding: 40px;
      .form_footer {
        margin-top: 20px;
        .submit {
          margin-right: 12px;
        }
      }
    }
  }
  .statu-info {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    width: 400px;
    padding: 10px;
    box-sizing: border-box;
  }
  .after-border {
    position: relative;
    &:after {
      height: 1px;
      background: rgba(255, 255, 255, 0.15);
      content: "";
      position: absolute;
      left: 0px;
      bottom: -8px;
      right: 20px;
      width: 100%;
    }
  }
  .message-item {
    margin-top: 16px;
    margin-bottom: 16px;
    line-height: 32px;
    .tab {
      .tab-item {
        float: left;
        margin-left: 10px;
      }
    }
  }
</style>

<script>
import r2Project from '@/assets/service/r2Project'
import AddMember from '@/views/project/children/component/AddMember'
import {mapGetters} from 'vuex'
import {getCookie} from '@/assets/utils/CommonUtil'
let role
switch (+getCookie('role')) {
  case 1:
    role = '管理员'
    break
  case 2:
    role = '总负责人'
    break
  case 3:
    role = '档案室负责人'
    break
  case 4:
    role = '普通员工'
    break
  default:
    role = '管理员'
    break
}
export default {
  name: 'ProjectAdd',
  components: {
    AddMember
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    showBackgroundColor: {
      type: Boolean,
      default: true
    },
    isEditor: {
      type: Boolean,
      default: false
    },
    showMemberTips: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const validatePrjNumber = (rule, value, callback) => {
      if (typeof value === 'string' && value.trim() === '') {
        return callback(new Error('请输入项目编号'))
      } else {
        callback()
      }
    }
    const validatePrjName = (rule, value, callback) => {
      if (typeof value === 'string' && value.trim() === '') {
        return callback(new Error('请输入项目名称'))
      } else if (value.match(/[\n"'+%<>|:?*]/) || value.indexOf('/') > -1 || value.indexOf('\\') > -1) {
        return callback(new Error('不能包含特殊字符'))
      } else {
        callback()
      }
    }
    return {
      show: false,
      statusMessage: {},
      sellist: [],
      form: {
        prjNumber: '',
        prjName: '',
        prjType: '',
        prjCategory: 0,
        description: '',
        memberIds: []
      },
      rules: {
        prjNumber: [
          {required: true, validator: validatePrjNumber, trigger: 'blur'}
        ],
        prjName: [
          {required: true, validator: validatePrjName, trigger: 'blur'}
        ],
        prjType: [
          {required: true, message: '请选择项目存储方式', trigger: 'change'}
        ],
        description: [
          {max: 200, message: '长度不能超过200字', trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'path'
    ]),
    status: function () {
      return Object.keys(this.statusMessage).map(item => ({
        value: 1,
        label: item
      }))
    }
  },
  watch: {
    'form.prjType': function (data) {
      if (+data === 1) {
        this.sentLog(100112011)
      } else {
        this.sentLog(100112012)
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 1.初始化
    init () {
      this.getPrjName()
    },
    // 2.添加成员
    addMember () {
      this.show = true
      this.sentLog(100112013)
    },
    // 3.1 获取项目模板信息
    getPrjName () {
      r2Project.getPrjPattern().then(res => {
        if (+res.code === 200) {
          this.statusMessage = res.data['1']
        }
      })
    },
    // 3.2 添加成员
    sellListCallBack (list) {
      this.sellist = list
      this.show = false
      this.sentLog(100112014)
    },
    // 3.3 移除成员
    closeHandle (item) {
      let delindex = 0
      this.sellist.map((selitem, index) => {
        if (selitem.id === item.id) {
          delindex = index
        }
      })
      this.sellist.splice(delindex, 1)
    },
    // 3.1 取消
    cancelHandle () {
      this.$refs.ruleForm.resetFields()
      this.$router.push({path: this.path})
    },
    // 3.2  提交
    submitHandle () {
      this.$refs.ruleForm.validate((valid) => {
        this.sentLog(100112015)
        if (valid) {
          let params = {}
          params.prjName = this.form.prjName
          params.prjNumber = this.form.prjNumber
          params.prjType = this.form.prjType
          params.prjCategory = this.form.prjCategory
          params.description = this.form.description
          params.url = window.location.origin + '/#/project/joined/list'
          params.prjMembers = this.sellist.map(item => ({memberId: item.memberId, roleId: item.role}))
          const loading = this.$loading({
            background: 'rgba(255,255,255,0.5)',
            img: '<span class="ant-spin-dot ant-spin-dot-spin"><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i></span>'
          })
          r2Project.postAddPrj(params).then((res) => {
            loading.close()
            if (+res.code === 200) {
              this.sendLogByCreateProject(params.prjCategory, res.code)
              this.$message.success('创建成功！')
              setTimeout(() => {
                this.$router.push({path: this.path})
              }, 500)
              this.addOperationRecords(10, params.prjName)
              // 项目添加员工
              if (this.sellist.length > 0) {
                this.addOperationRecords(13, this.sellist, {
                  action: 'addMember'
                })
              }
            } else if (+res.code === 270001) {
              this.$message.error('项目名称已存在')
            } else if (+res.code === 270004) {
              this.$message.error('项目编号已存在')
            } else {
              this.sendLogByCreateProject(params.prjCategory, res.code)
              this.$message.error(res.message || '创建失败！')
            }
          }).catch(() => {
            this.sendLogByCreateProject(params.prjCategory)
            this.$message.error('创建失败！')
            loading.close()
          })
        }
      })
    },
    // 埋点：创建项目
    sendLogByCreateProject (prjCategory = 0, code) {
      let extJson = {status: 1}
      if (code !== 200) {
        Object.assign(extJson, {
          status: 0,
          code
        })
      }
      (prjCategory === 1) && this.sentLog(100112057, extJson)
    },
    // 4.4 用户行为
    prjTypeHover (data) {

    },
    // 修改造价文件编制方式 0 1
    changeCategory (value) {
      if (value) {
        this.form.prjType = '0'
      } else {
        this.form.prjType = ''
      }
    }
  }
}
</script>
